import { z } from 'zod';

export const gameOverviewCrestSchema = z
	.object({
		url: z.string().optional(),
		altText: z.string().optional(),
		imageVariants: z
			.array(
				z
					.object({
						alias: z.string().optional(),
						url: z.string().optional(),
					})
					.passthrough()
			)
			.nullish(),
	})
	.passthrough();

const gameOverviewMediaSchema = z
	.object({
		url: z.string().optional(),
		alt: z.string().optional(),
		altText: z.string().optional(),
		width: z.number().optional(),
		height: z.number().optional(),
	})
	.passthrough();

const gameOverviewResponsiveImageSchema = z
	.object({
		portraitImage: gameOverviewMediaSchema.optional(),
		landscapeImage: gameOverviewMediaSchema.optional(),
		doNotCrop: z.boolean().optional(),
	})
	.passthrough();

const gameOverviewCompetitionCrestSchema = z.union([
	z.string(),
	gameOverviewCrestSchema,
]);

export const gameOverviewSchema = z
	.object({
		location: z
			.object({
				name: z.string().optional(),
				address: z.string().optional(),
			})
			.passthrough()
			.optional(),
		referee: z.string().optional(),
		matchTime: z.string().optional(),
		matchMinute: z.number().optional(),
		awayTeamName: z.string().optional(),
		homeTeamName: z.string().optional(),
		period: z.string().optional(),
		competition: z
			.object({
				name: z.string().optional(),
				crest: gameOverviewCompetitionCrestSchema.optional(),
				colouredCrest: gameOverviewCompetitionCrestSchema.optional(),
				id: z.number().optional(),
			})
			.passthrough()
			.optional(),
		homeTeamScorers: z.array(z.unknown()).optional(),
		awayTeamScorers: z.array(z.unknown()).optional(),
		awayTeamCrest: gameOverviewCrestSchema.optional(),
		homeTeamCrest: gameOverviewCrestSchema.optional(),
		homeTeamScore: z.number().optional(),
		awayTeamScore: z.number().optional(),
		awayTeamId: z.number().optional(),
		homeTeamId: z.number().optional(),
		kickOffUTC: z.string().optional(),
		isHomeGame: z.boolean().optional(),
		isLive: z.boolean().optional(),
		isPostMatch: z.boolean().optional(),
		isInCountdownMode: z.boolean().optional(),
		isHalfTime: z.boolean().optional(),
		isMatchDayAudio: z.boolean().optional(),
		pageUrl: z.string().optional(),
		optaId: z.union([z.number(), z.string()]).optional(),
		videoId: z.string().optional(),
		cityPlusVideoId: z.string().nullish(),
		cityPlusCtaButtonLabel: z.string().optional(),
		signInRequiredVideoId: z.string().optional(),
		signInRequiredCtaButtonLabel: z.string().optional(),
		headerBackground: gameOverviewResponsiveImageSchema.optional(),
		headerPlaceholder: gameOverviewResponsiveImageSchema.optional(),
		statusBarBackground: gameOverviewMediaSchema.nullish(),
	})
	.passthrough();

export type GameOverview = z.infer<typeof gameOverviewSchema>;
